import React from 'react'

import FrontWall from './FrontWall'
import BackWall from './BackWall'
import RightWall from './RightWall'
import LeftWall from './LeftWall'
import { params } from '../../../../redux/reducers/reducer'

const Walls = () => {

    return (
        <>
            {/* {(params.p_f_w != "Open" || params.cB_addStorage_check_left || params.cB_addStorage_check_right) && <FrontWall />}
            {(params.p_b_w != "Open" || params.p_u_c || params.cB_addStorage_check_left || params.cB_addStorage_check_right) && <BackWall /> }
            {((params.p_r_w != "Open" || (params.p_r_w == "Open" && params.p_c_p_r)) || params.p_u_c || params.cB_addStorage_check_left || params.cB_addStorage_check_right) && <RightWall /> }
            {((params.p_l_w != "Open" || (params.p_l_w == "Open" && params.p_c_p_l)) || params.p_u_c || params.cB_addStorage_check_left || params.cB_addStorage_check_right) && <LeftWall /> } */}

            <FrontWall />
            <BackWall />
            <RightWall />
            <LeftWall />
        </>
    )
}

export default Walls